import type { StateTree } from '@makemydeal/dr-dash-types';

const getGlobalPrintingSettingsState = (state: StateTree) => state.globalPrintingSettings;

export const getGlobalPrintingSettingsLogoUrl = (state: StateTree): string =>
    getGlobalPrintingSettingsState(state)?.logo.logoUrl ?? '';

export const getGlobalPrintingSettingsIsLoading = (state: StateTree): boolean =>
    getGlobalPrintingSettingsState(state)?.logo.isLoading ?? false;

export const getGlobalPrintingSettingsHasFetched = (state: StateTree): boolean =>
    getGlobalPrintingSettingsState(state)?.logo.hasFetched ?? false;

export const getGlobalPrintingSettingsError = (state: StateTree): string => getGlobalPrintingSettingsState(state)?.logo.error ?? '';

export const getGlobalPrintingSettingsFileName = (state: StateTree): string =>
    getGlobalPrintingSettingsState(state)?.logo.file?.fileName ?? '';

export const getGlobalPrintingSettingsFileSize = (state: StateTree): number =>
    getGlobalPrintingSettingsState(state)?.logo.file?.size ?? 0;

export const getGlobalPrintingSettingsImageWidth = (state: StateTree): number =>
    getGlobalPrintingSettingsState(state)?.logo.file?.imageWidth ?? 0;

export const getGlobalPrintingSettingsImageHeight = (state: StateTree): number =>
    getGlobalPrintingSettingsState(state)?.logo.file?.imageHeight ?? 0;

export const getGlobalPrintingSettingsLastOp = (state: StateTree): 'upload' | 'delete' | null =>
    getGlobalPrintingSettingsState(state)?.logo.lastOp ?? null;

/**
 * Returns the logo URL to use for PDF printing: the uploaded global printing logo URL,
 * or undefined if none has been uploaded.
 */
export const getPrintingLogoUrl = (state: StateTree): string | undefined => getGlobalPrintingSettingsLogoUrl(state) || undefined;
